import { CustomDialog } from '@/model/CustomDialog.model';
import { IGalleria } from '@/model/IGalleria.model';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';
class LayoutService {
  public sidebarLeftSub = new BehaviorSubject(false);
  public getSidebarLeftState = this.sidebarLeftSub.asObservable();

  public sidebarRightSub = new BehaviorSubject(false);
  public getSidebarRightState = this.sidebarRightSub.asObservable();

  public dialogSub = new BehaviorSubject<CustomDialog>({ show: false, name: "" });
  public getDialog = this.dialogSub.asObservable();

  public loadingSub = new BehaviorSubject(false);
  public getLoading = this.loadingSub.asObservable();

  public galleriaSub = new BehaviorSubject<IGalleria>({
    value: [],
    responsiveOptions: "responsiveOptions",
    numVisible: 8,
    containerStyle: "max-width: 850px",
    circular: true,
    fullScreen: true,
    showItemNavigators: true,
    showThumbnails: false,
    visible: false
  });
  public getGalleria = this.galleriaSub.asObservable();

  public setStateSidebarLeft(state: boolean) {
    return this.sidebarLeftSub.next(state)
  }
  public setStateSidebarRight(state: boolean) {
    return this.sidebarRightSub.next(state)
  }

  public setGalleria(galleria: IGalleria) {
    return this.galleriaSub.next(galleria);
  }

  public setDialog(dialog: any) {
    this.dialogSub.next(dialog);
    return new Observable(sub => {
      sub.next(dialog)
    })
  }

  public setLoading(state: boolean) {
    return this.loadingSub.next(state);
  }
}

export default new LayoutService();
